(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-related-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('.testimonials-slider');
  if (!root) return;

  const viewport   = root.querySelector('[data-viewport]');
  const track      = root.querySelector('[data-track]');
  const slides     = Array.from(track.children);
  const prevBtn    = root.querySelector('[data-prev]');
  const nextBtn    = root.querySelector('[data-next]');
  const pagination = root.querySelector('[data-pagination]');

  const mqTablet = window.matchMedia('(max-width: 991px)');
  const mqMobile = window.matchMedia('(max-width: 575px)');

  function perPage() {
    if (mqMobile.matches) return 2;
    if (mqTablet.matches) return 2;
    return 3;
  }

  let pageIndex = 0;

  function pageCount() {
    return Math.max(1, Math.ceil(slides.length / perPage()));
  }

  function goTo(i) {
    const count = pageCount();
    pageIndex = Math.max(0, Math.min(i, count - 1));
    viewport.scrollTo({ left: viewport.clientWidth * pageIndex, behavior: 'smooth' });
    updateUI();
  }

  function updateUI() {
    const count = pageCount();
    prevBtn.disabled = pageIndex === 0;
    nextBtn.disabled = pageIndex >= count - 1;

    pagination.innerHTML = '';
    for (let i = 0; i < count; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'testimonials-slider__dot' + (i === pageIndex ? ' is-active' : '');
      dot.addEventListener('click', () => goTo(i));
      pagination.appendChild(dot);
    }
  }

  prevBtn.addEventListener('click', () => goTo(pageIndex - 1));
  nextBtn.addEventListener('click', () => goTo(pageIndex + 1));

  let resizeTO;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTO);
    resizeTO = setTimeout(() => { goTo(pageIndex); }, 100);
  });

  updateUI();
  goTo(0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
